import type { FormatCapabilities } from '../types';

export const pdfCapabilities: FormatCapabilities = {
  supportsColor: true,
  supportsOpacity: true,
  supportsCustomFonts: true,
  supportsSvgShapes: true,
  supportsLetterSpacing: true,
  supportsReelSplitting: true,
  supportsPageLayout: true,
  supportsShapeFill: true,
  supportsBackgroundColor: true,
};
